import { Observable, combineLatest } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 *  distinctUntilChanged() Only emit when the current value is different than the last.
 */

export const muteFirst = <T, R>(first$: Observable<T>, second$: Observable<R>) => {
    const obs = combineLatest(
        first$,
        second$,
        (a, b) => b
    );
    return obs.pipe(
        distinctUntilChanged()
    );
};
